<template>
    <div>
        <header
            class="flex w-full md:relative md:h-[22rem] overflow-hidden mt-6"
            :class="[!$slots.figure ? 'bg-gray-100 rounded-xl' : 'md:rounded-xl']"
        >
            <slot name="header" />

            <section
                class="bg-gray-100 w-full z-[1] flex flex-col justify-between px-8 pt-5 pb-8 md:mt-0 rounded-xl md:rounded-none"
                :class="[!$slots.figure ? 'mt-2' : 'mt-[5.5rem]']"
            >
                <slot />
            </section>

            <figure
                v-if="$slots.figure"
                class="absolute md:relative top-0 md:top-auto left-0 md:left-auto w-full max-w-none md:grow md:hidden"
            >
                <slot name="figure" />

                <div
                    class="absolute w-full h-full block top-0 bg-[linear-gradient(180deg,_transparent_55%,_white_95%)] md:hidden"
                    aria-hidden="true"
                />
            </figure>
        </header>

        <div
            v-if="$slots.creditLine"
            class="text-sm text-gray-500 px-4 py-2"
        >
            <slot name="creditLine" />
        </div>
    </div>
</template>

<style scoped>
header {
    --angle-width: 300px;
    --section-max-width: 864px;
}

@screen md {
    section {
        clip-path: polygon(
            0% -1px,
            100% -1px,
            calc(100% - var(--angle-width)) 100%,
            0% 100%
        );
        max-width: var(--section-max-width);
        margin-right: calc((var(--section-max-width) * -1) + var(--angle-width));
    }

    figure {
        @apply block;

        min-width: var(--angle-width);
        max-width: calc(100% - var(--section-max-width) + var(--angle-width));
        right: calc((var(--section-max-width) * -1) + var(--angle-width));
        margin-left: calc(var(--angle-width) * -1);
    }
}
</style>
